//@flow
import React from 'react';
import i18n from 'app/common/lib/i18n';
import { Link } from 'gestalt';

export const helpURL =
  'https://help.pinterest.com/login-request?what_do_you_need_help_with=Getting+into+my+account&tell_more_account_access=Appeal+account+suspension';
export const SuspendedUserLink = () => (
  <Link inline href={helpURL}>
    {i18n._(
      'get in touch with us',
      'link text shown to redirect to help.pinterest.com for appealing a suspension',
    )}
  </Link>
);
